class LocalStorageService {
  private readonly KEY_AUTH_TOKEN = 'AUTH-TOKEN';

  get authToken(): string {
    return localStorage.getItem(this.KEY_AUTH_TOKEN);
  }

  set authToken(v: string) {
    localStorage.setItem(this.KEY_AUTH_TOKEN, v);
  }

  removeAuthToken() {
    localStorage.removeItem(this.KEY_AUTH_TOKEN);
  }
}

export const localStorageService = new LocalStorageService();
